var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nav-item-tree overflow-visible d-flex flex-column"
  }, [_vm.level > 1 ? _c('button', {
    staticClass: "btn back-button font-weight-semibold flex-shrink-0",
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('MdmIcon', {
    staticClass: "back-icon",
    attrs: {
      "size": "30",
      "name": "chevron-left"
    }
  }), _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav-list list-unstyled flex-shrink-1 m-0"
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item.id,
      class: _vm.itemClass(item.type)
    }, [_c(_vm.componentName(item.type), {
      key: item.id,
      ref: _vm.componentName(item.type),
      refInFor: true,
      tag: "component",
      attrs: {
        "is-scramble-link": _vm.isScrambleTransformation(item),
        "level": _vm.level,
        "item": item,
        "with-color": _vm.withColor
      }
    })], 1);
  }), 0), _vm._v(" "), _vm.mea && _vm.mea.length ? _c('ul', {
    staticClass: "list-unstyled flex-shrink-1 mt-4 pt-3 px-3 mea-container"
  }, _vm._l(_vm.mea, function (group) {
    return _c('li', {
      key: group.id,
      staticClass: "pb-3 mea-group"
    }, [_c('p', {
      staticClass: "font-weight-semibold px-3 mea-title",
      domProps: {
        "textContent": _vm._s(group.label)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "nav-list list-unstyled flex-shrink-1 m-0"
    }, _vm._l(group.items, function (item) {
      return _c('li', {
        key: item.id
      }, [_c(_vm.componentName(item.type), {
        key: item.id,
        ref: _vm.componentName(item.type),
        refInFor: true,
        tag: "component",
        attrs: {
          "is-scramble-link": _vm.isScrambleTransformation(item),
          "level": _vm.level,
          "item": item,
          "with-color": _vm.withColor,
          "with-arrow": _vm.isMenuOpened
        }
      })], 1);
    }), 0)]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };